// 合并table行
// 计算合并行数
export const getMergeRowNum = (col_name, row, dataSource, compare_col_name = null) => {
    const temp = {};
    let n = 0;
    if (col_name !== temp[col_name]) {
    temp[col_name] = row[col_name];

    dataSource.forEach((e) => {
        if (compare_col_name !== null) {
        if (e[col_name] === temp[col_name] && e[compare_col_name] === row[compare_col_name]) {
            n += 1;
        }
        } else {
        if (e[col_name] === temp[col_name]) {
            n += 1;
        }
        }
    })
    }
    return n
}

export const renderRow = (value, row, index ,key, data) => {
    const obj = {
    children: typeof(value)=='function'?value():value,
    props: {},
    };

    // 与上一行不同，计算行数
    if ((index > 0 && row[key] !== data[index - 1][key]) || index === 0) {
    obj.props.rowSpan = getMergeRowNum(key, row, data);
    } else {
    obj.props.rowSpan = 0;
    }
    return obj;
}


// WEBPACK FOOTER //
// ./src/components/common/combineTable.js